import { render, staticRenderFns } from "./ServiceActivityCard.vue?vue&type=template&id=1fc21da2&scoped=true"
import script from "./ServiceActivityCard.vue?vue&type=script&lang=js"
export * from "./ServiceActivityCard.vue?vue&type=script&lang=js"
import style0 from "./ServiceActivityCard.vue?vue&type=style&index=0&id=1fc21da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc21da2",
  null
  
)

export default component.exports